import { ISurveyHeaderItem } from "../common/data/dtos/survey-header-item";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/SurveyHeaderItem';

interface SurveyHeaderItemResponse {
    success: boolean;
    surveyHeaderItem?: ISurveyHeaderItem;
    surveyHeaderItems?: ISurveyHeaderItem[];
    error?: string;
}

type CreateSurveyHeaderItemType = Omit<ISurveyHeaderItem, 'id'> | Partial<ISurveyHeaderItem>;

const createSurveyHeaderItem = async (surveyHeaderItem: CreateSurveyHeaderItemType): Promise<SurveyHeaderItemResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ISurveyHeaderItem>(`${BASE_PATH}`, surveyHeaderItem);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const createManySurveyHeaderItem = async (surveyHeaderItems: CreateSurveyHeaderItemType[]): Promise<SurveyHeaderItemResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ISurveyHeaderItem>(`${BASE_PATH}`, surveyHeaderItems);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteSurveyHeaderItem = async (id: string): Promise<SurveyHeaderItemResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<ISurveyHeaderItem>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getSurveyHeaderItems = async (): Promise<SurveyHeaderItemResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyHeaderItem>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyHeaderItems: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneSurveyHeaderItem = async (id: string): Promise<SurveyHeaderItemResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyHeaderItem>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyHeaderItem: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateSurveyHeaderItem = async (surveyHeaderItem: ISurveyHeaderItem): Promise<SurveyHeaderItemResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<ISurveyHeaderItem>(`${BASE_PATH}/${surveyHeaderItem.id}`, surveyHeaderItem);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getSurveyHeaderItemBySurveyHeader = async (id: string): Promise<SurveyHeaderItemResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyHeaderItem>(`${BASE_PATH}/GetBySurveyHeader?id=${id}`);
        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyHeaderItems: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createSurveyHeaderItem,
    createManySurveyHeaderItem,
    deleteSurveyHeaderItem,
    getSurveyHeaderItems,
    getOneSurveyHeaderItem,
    updateSurveyHeaderItem,
    getSurveyHeaderItemBySurveyHeader
};